// src/components/profiles/filters/types.js
export const DEFAULT_FILTERS = {
  // Basic filters
  gender: 'all',
  ageRange: [18, 60],
  city: '',
  profession: '',
  religion: '',
  education: '',
  maritalStatus: 'all',
  verified: false,
  
  // Advanced filters
  sect: '',
  caste: '',
  familyType: '',
  familyStatus: '',
  incomeRange: [0, 500000],
  height: '',
  bodyType: '',
  hobbies: [],
  languages: [],
  lifestyleHabits: [],
  
  // Self details
  selfDetails: {
    enabled: false,
    gender: '',
    ageRange: [25, 35],
    height: '',
    income: '',
    education: ''
  }
};